(function () {
    'use strict';
    var controllerId = 'studenteAdd';

    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'common', 'sectionMenu', 'classi', 'classeId', 'societaId', studenteAdd]);

    function studenteAdd($scope, $uibModalInstance, datacontext, common, sectionMenu, classi, classeId, societaId) {
        $scope.studente = {};
        $scope.classi = classi;
        $scope.getSocieta = getSocieta;
        $scope.societa = [];
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        
        //Parametro classeId utilizzato per impostare e bloccare selezione Classe
        //Utilizzato in caso di creazione un nuovo studente da view /app/classe/classeDetail.html
        if (classeId) {
            $scope.classeId = classeId;
            $scope.studente.ClasseId = classeId;
        }

        if (societaId) {
            $scope.societaId = societaId;
            $scope.studente.SocietaId = societaId;
        }

        $scope.ok = function (isValid) {           
            if (isValid) {
                addItem($scope.studente).then(function (result) {
                    //console.dir(result);
                    if (result == '502') logError('Username gi&agrave; registrata');
                    else if (!result || result.Id == null || result.Id == 0) $uibModalInstance.close(null);
                    else $uibModalInstance.close(result);
                });                
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.suggest = function () {
            if (!$scope.studente.Nome || !$scope.studente.Cognome)
                return;
            
            datacontext.user_suggestUserame($scope.studente.Nome, $scope.studente.Cognome).then(function (username) {
                if (!username || username.trim().length == 0)
                    return;

                $scope.studente.Username = username;

                datacontext.user_suggestPassword($scope.studente.Nome).then(function (password) {                    
                    if (!password || password.trim().length == 0)
                        return;

                    $scope.studente.Password = password;
                });
            });
        };       

        function addItem(item) {
            var classi = new Array();
            classi.push(item.ClasseId);

            return datacontext.studente_add(item).then(function (data) {
                return data;
            });
        }

        // funzione che permette di visualizzare l'[id] RagioneSociale (Comune) della societ� e non l'id
        $scope.formatLabelSocieta = function (model) {
            for (var i = 0; i < $scope.societa.length; i++) {
                if (model === $scope.societa[i].Id) {
                    $scope.studente.Societa = '[' + $scope.societa[i].Id + ']' + ' ' + $scope.societa[i].RagioneSociale + ' ' + '(' + $scope.societa[i].Comune + ')';
                    return $scope.studente.Societa;
                }
            }
        };

        function getSocieta(ricerca) {

            $scope.studente.SocietaId = ricerca;
            return datacontext.societa_getAllByFilter($scope.studente.SocietaId, ricerca).then(function (data) {
                if (Array.isArray(data) && data.length > 0) {
                    $scope.societa = data;
                    return $scope.societa;
                }
                return null;
            });
        }
    }
})();